import { useEffect, useState } from "react";

/**
 * 模拟前端数据加载（本站为纯前端演示，无真实后台接口）。
 * 通过短暂延迟演示加载骨架，便于展示加载与空状态。
 */
export function useMockLoading(delay = 450): boolean {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return loading;
}